import BaseHttpService from "./https.service";

const isLocal = window.location.href.indexOf('localhost') >= 0;
const managerBaseUrl = isLocal ? 'http://localhost:5001/manager' : '/manager';

class BucketService extends BaseHttpService {
    constructor() {
        super(managerBaseUrl); 
    }

    async uploadImage(file, base64File, data) {
        const payload = {
            name: file.name,
            size: file.size,
            type: file.type,
            content: base64File,
            additionalData: {...data}
        };
        
        try {
            const response = await this.post(`/image/upload`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            console.log('File uploaded successfully:', response);
            return response;
        } catch (error) {
            console.error('Upload failed:', error);
            
            // Handle specific error codes
            if (error.response) {
                const status = error.response.status;
                if (status === 413) {
                    throw new Error('Image file is too large. Please use an image smaller than 10MB.');
                } else if (status === 400) {
                    throw new Error(error.response.data?.message || 'Invalid image upload request.');
                } else if (status === 500) {
                    throw new Error('Server error while uploading image. Please try again.');
                }
            }
            
            throw new Error('Failed to upload image. Please check your connection and try again.');
        }
    }

    async getImages(experimentId){
        return this.get(`/image/get-urls`, {experimentId})
    }

    async deleteImage(imageId, experimentId, filename) {
        return this.post(`/image/delete-image`, { imageId, experimentId, filename });
    }
}



export const bucketService = new BucketService();